import { __assign } from "tslib";
var LOCAL_STORAGE_KEY = 'marvel3';
var canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
export function reset(storageKey) {
    if (storageKey === void 0) { storageKey = LOCAL_STORAGE_KEY; }
    if (canUseDOM) {
        window.localStorage.removeItem(storageKey);
    }
}
function readCache(storageKey) {
    if (canUseDOM) {
        try {
            var ls = window.localStorage;
            var rawCache = ls.getItem(storageKey) || '{}';
            return JSON.parse(rawCache);
        }
        catch (e) {
            // This means the JSON is corrupt, let's clear it and start again
            reset();
            return {};
        }
    }
}
export function get(key, storageKey) {
    if (storageKey === void 0) { storageKey = LOCAL_STORAGE_KEY; }
    if (canUseDOM) {
        return readCache(storageKey)[key];
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function set(key, value, storageKey) {
    var _a;
    if (storageKey === void 0) { storageKey = LOCAL_STORAGE_KEY; }
    if (canUseDOM) {
        setCache(__assign(__assign({}, readCache(storageKey)), (_a = {}, _a[key] = value, _a)), storageKey);
    }
}
export function remove(key, storageKey) {
    if (storageKey === void 0) { storageKey = LOCAL_STORAGE_KEY; }
    if (canUseDOM) {
        var currentCache = readCache(storageKey);
        // delete specific property off the marvel3 object in cache
        delete currentCache[key];
        setCache(currentCache, storageKey);
    }
}
function setCache(value, storageKey) {
    window.localStorage.setItem(storageKey, JSON.stringify(value));
}
export function getMatchingValueFromCache(cacheKey, options) {
    if (!cacheKey)
        return null;
    var keyFromCache = get(cacheKey);
    return options.find(function (_a) {
        var key = _a.key;
        return key === keyFromCache;
    }) ? keyFromCache : null;
}
